export default [
  {
    path: 'horaire/:date?',
    component: () => import('src/pages/gestionHoraire/index.vue')
  },
  {
    path: 'horaire/copyweek',
    component: () => import('src/pages/gestionHoraire/copyLastWeek/index.vue')
  }
];
